/* Presets backtest (reconstruction Helius slot-1 × TP modeste).
   SOURCE UNIQUE FRONTEND — doit matcher EXACTEMENT §2.1 de la spec + le backend.
   Réutilisé par BacktestLaunchForm (drill-down) ET la page Backtests. */

export const TP_PCT_ALLOWED = [10, 20, 30, 40, 50];          // multi ; défaut [10,20,30]
export const SIZE_SOL_ALLOWED = [0.01, 0.05, 0.1, 0.25, 0.5]; // multi ; défaut [0.05]
export const ENTRY_OFFSET_ALLOWED = [0, 1, 2];                // single ; défaut 1
export const EXIT_LATENCY_ALLOWED = [0, 250, 500, 1000];      // single ; défaut 250
export const STOP_PCT_ALLOWED = [0, 25, 35, 50];              // single ; défaut 35 (0 = off)
export const MAX_PICKS_ALLOWED = [20, 30, 50, 100];           // single ; défaut 30
export const PICK_ORDER_ALLOWED = ['newest', 'oldest'];       // single ; défaut 'newest'

export const MATRIX_MAX = 25; // len(tp_list) * len(size_list) ≤ 25

// Matrice canonique utilisée par le bouton « Backtester tout » (Feature B).
// Doit rester bit-identique aux Global Constraints du plan + CANONICAL_BACKTEST_PARAMS backend.
export const CANONICAL_BATCH = {
  tp_list: [10, 20, 30],
  size_list: [0.05],
  exit_latency_ms: 250,
  stop_pct: 35,
  max_picks: 30,
  pick_order: 'newest',
};

export const DEFAULTS = {
  tp_list: [10, 20, 30],
  size_list: [0.05],
  entry_slot_offset: 1,
  exit_latency_ms: 250,
  stop_pct: 35,
  max_picks: 30,
  pick_order: 'newest',
};
